var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconExternalLink16 = function SvgIconExternalLink16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-purple500, #872AB0)",
    d: "M4 7v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h1v1H5a1 1 0 0 0-1 1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-purple500, #872AB0)",
    fillRule: "evenodd",
    d: "M11 5H8V4h4v4h-1z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-purple500, #872AB0)",
    fillRule: "evenodd",
    d: "m6.646 8.646 4.5-4.5.708.708-4.5 4.5z",
    clipRule: "evenodd"
  })));
};
export default SvgIconExternalLink16;